<modal (close)="onClose()" data-testid="selection-modal">
  <modal-content>

    <div class="selection">
      <h2 class="selection__title" data-testid="selection-modal-title">
        {{ title }}
      </h2>

      <div class="selection__list" data-testid="modal-selection-list">
        <app-selection-list
          [selectionItems]="selectionItems">
        </app-selection-list>
      </div>
    </div>

  </modal-content>
</modal>
